import { render, staticRenderFns } from "./Sheet.vue?vue&type=template&id=51844a01&scoped=true"
import script from "./Sheet.vue?vue&type=script&lang=ts"
export * from "./Sheet.vue?vue&type=script&lang=ts"
import style0 from "./Sheet.vue?vue&type=style&index=0&id=51844a01&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51844a01",
  null
  
)

export default component.exports